// Copyright (c) Bentley Systems
export class Parameter {
  public name: string | undefined;
  public value: string | undefined;

  constructor(name: string | undefined, value: string | undefined) {
    this.name = name;
    this.value = value;
  }
}
